import React from 'react'

export default function Loading() {
  return (
    <div id="cover-spin"></div>
  )
}
